// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/plugins/copyPaste/copyPaste.css
// module id = 463
// module chunks = 0